import { render, staticRenderFns } from "./CustomSpacer.vue?vue&type=template&id=e8fd8252&scoped=true&"
import script from "./CustomSpacer.vue?vue&type=script&lang=js&"
export * from "./CustomSpacer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8fd8252",
  null
  
)

export default component.exports